/** Number in the PBI `#,0` style (thousands separators, no decimals). Null → dash. */
export function fmtNum(v: number | null | undefined): string {
    if (v === null || v === undefined) return '–';
    return Math.round(v).toLocaleString('de-CH');
}

/** Date as dd.MM.yyyy (PBI). Null → dash. Parsed as a plain calendar date (no TZ shift). */
export function fmtDate(v: string | null | undefined): string {
    if (!v) return '–';
    // v is an ISO string; take the date part to avoid CET/CEST midnight shifts.
    const datePart = v.slice(0, 10);
    const [y, m, d] = datePart.split('-');
    if (!y || !m || !d) return '–';
    return `${d}.${m}.${y}`;
}

export type Ampel = 'red' | 'amber' | 'green';

/**
 * The word for each light (design audit 2026-10-07, S1-07) — a colour on its own says nothing to
 * a screen reader and little to anybody who has not been told what it means. Red stays "Overdue"
 * by decision (ND-01): this page's vocabulary, shared with Customer 360's At Risk tab.
 */
export const AMPEL_LABEL: Record<Ampel, string> = {
    red: 'Overdue',
    amber: 'Due',
    green: 'In cycle',
};

/**
 * The unit of the KPI figures for the current mode (design audit S1-06): EUR for net sales and
 * gross profit, "qty" for quantity — each product in its own sales unit, mostly kg, which the
 * transactions modal names per row.
 */
export function kpiUnit(mode: 'net' | 'quantity' | 'grossprofit'): string {
    return mode === 'quantity' ? 'qty' : 'EUR';
}

/**
 * Traffic light, replicating the PBI IconCycle measure.
 * avg BLANK-semantics: null AvgCycle behaves as 0 (DAX BLANK()+90 = 90). MANDATORY.
 */
export function ampel(daysSince: number | null, avgCycle: number | null): Ampel {
    const days = daysSince ?? 0;
    const avg = avgCycle ?? 0;
    if (days > avg + 90) return 'red';
    if (days > avg) return 'amber';
    return 'green';
}
